<template>
  <div class="rec-keywords">
    <ul class="recommend-word">
      <li
        class="recommend-word-item"
        :class="[activeIndex === index ? 'active' : '']"
        @click="changeIndexHandle(index)"
        v-for="(item, index) of recommendKeywords"
        :key="index"
      >
        {{ item }}
      </li>
    </ul>
    <div class="refresh-btn"><refresh-btn @refresh="refresh"></refresh-btn></div>
  </div>
</template>

<script>
import { TodaySearchService } from "@/service";
import {WinForm} from '@/libs'

import RefreshBtn from './components/refresh-btn.vue';

export default {
  components: { RefreshBtn },
  props: {
    rightLoading: { default: false },
    activeIndex: { default: 0 },
  },
  data() {
    return {
      recommendKeywords: [], // 推荐的感兴趣的词
    }
  },
  mounted() {
    this.getRecommed();
  },
  methods: {
    refresh() {
      this.$emit('indexChange', 0);
      this.getRecommed();
    },
    changeIndexHandle(index) {
      this.$emit('indexChange', index);
      this.recommendProducts();
    },
    // 获取推荐词
    async getRecommed() {
      const res = await TodaySearchService.getSearchKeyword("", 40, true);
      if (res.code === 0) {
        this.recommendKeywords = res.data;
        this.recommendProducts();
        this._setRecommedInterval();
      }
    },
    // 用户无操作时的关键词自动切换
    _setRecommedInterval() {
      this._clearRecommedInterval();
      this.recommedInterval = setInterval(() => {
        if (this.rightLoading) return;
        if (document.visibilityState === 'hidden') return;
        if (WinForm.md.getWindowState() === 1) return;
        if (WinForm.md.getTabIndex() !== 0) return;
        let indexNum = this.activeIndex >= (this.recommendKeywords.length - 1) ? 0 : this.activeIndex + 1;
        
        const offsetTop = document.querySelectorAll('.recommend-word-item')[indexNum].offsetTop;
        if (offsetTop > 56) {
          indexNum = 0;
        }

        this.$emit('indexChange', indexNum);
        this.recommendProducts();
      }, 10000)
    },
    // 相对应的定时任务清除
    _clearRecommedInterval() {
      this.recommedInterval && clearInterval(this.recommedInterval);
    },
    // 推荐词查询产品
    recommendProducts() {
      this.$emit('recommendProducts');
    },
  },
}
</script>

<style lang="less" scoped>
  .rec-keywords{
    padding: 14px 10px;
    height: 84px;
    position: relative;
    background: #ffffff;
  }
  .refresh-btn{
    position: absolute;
    right: 10px;
    bottom: 12px;
    line-height: 26px;
  }
  .recommend-word{
    display: flex;
    flex-wrap: wrap;
    padding-right: 30px;
    height: 58px;
    overflow: hidden;
  }
  .recommend-word-item{
    font-size: 13px;
    color: #2F3748;
    height: 26px;
    line-height: 24px;
    border: 1px solid transparent;
    cursor: pointer;
    margin-right: 12px;
    margin-bottom: 5px;
    border: 1px solid transparent;
  }
  .recommend-word-item.active{
    border-bottom: 1px solid #0989C5;
    color: #0989C5;
    font-weight: bold;
  }
</style>
